export const CSS_CLASSES = {
  TABS_ROOT: "tabs-root",
  TABS_VERTICAL: "tabs-vertical",

  TAB: "tab",
  TAB_ACTIVE: "tab-active",
  TAB_INACTIVE: "tab-inactive",
  TAB_DISABLED: "tab-disabled",
  TAB_LIST: "tab-list",
  TAB_PANEL_ACTIVE: "tab-panel-active",
  TAB_DESKTOP: "tab-desktop",
  TAB_MOBILE: "tab-mobile",
};
